import { axiosInstance } from "../services/axiosInstance";
import catchAsync from "../utils/catchAsync";

export const addSupplierGroup = catchAsync(async (body) => {
  const { data } = await axiosInstance.post(
    '/api/resource/Supplier Group',
    body
  );
  return data;
});
export const updateSupplierGroup = catchAsync(async (body, id) => {
  const { data } = await axiosInstance.put(
    `/api/resource/Supplier Group/${id}`,
    body
  );
  return data;
});

export const getSupplierGroup = catchAsync(async ({key="",value=""}) => {
  let baseUrl = '/api/resource/Supplier Group?fields=["name","is_group","accounts.account"]&limit_start=0&limit_page_length=0'
  if (value) {
    baseUrl += `&filters=[["${key}","like","%${value}%"]]`;
  }
  const { data } = await axiosInstance.get(
    baseUrl
  );
  return data;
});
export const deleteSupplierGroup = catchAsync(async (record) => {
  const { data } = await axiosInstance.delete(
    `/api/resource/Supplier Group/${record}`
  );
  return data;
});
export const getSupplierGroupDetails = catchAsync(async (id) => {
  const { data } = await axiosInstance.get(
    `/api/resource/Supplier Group/${id}`
  );
  return data;
});